import type { VisioLink } from '@gozoki/api-types'
import { useMutation } from '@tanstack/react-query'
import { fetchAskVisio } from '../queries/visio.queries'

interface AskVisioVariables {
  kioskId: number
  includeVideo: boolean
  openingEventId?: number
}

export const useAskVisio = () =>
  useMutation<VisioLink, Error, AskVisioVariables>({
    mutationFn: ({ kioskId, includeVideo, openingEventId }) =>
      fetchAskVisio(kioskId, includeVideo, openingEventId),
    meta: { errorMessage: "Impossible de démarrer l'appel" },
  })
